export const num = (value: number | null | undefined): string =>
  (value ?? 0).toLocaleString();

export function timeAgo(seconds: number): string {
  const delta = Date.now() / 1000 - seconds;
  if (delta < 60) return `${Math.max(0, Math.floor(delta))}s ago`;
  if (delta < 3600) return `${Math.floor(delta / 60)}m ago`;
  if (delta < 86400) return `${Math.floor(delta / 3600)}h ago`;
  return new Date(seconds * 1000).toLocaleDateString();
}

/** The shared meter colouring: green until it starts to matter. */
export function meterClass(pct: number, warn: number, bad: number): string {
  return "meter" + (pct > bad ? " bad" : pct > warn ? " warn" : "");
}
